import React, { HTMLAttributes } from 'react';

export const MarkdownUnorderedList: React.FC<HTMLAttributes<HTMLUListElement>> = ({ children }) => {
  return <ul className={'list-inside list-disc whitespace-normal'}>{children}</ul>;
};
